import { ReactElement } from 'react'
import AppHeader from './partials/AppHeader'
import {
    LayoutRSC as Layout,
    LayoutContentPaneRSC as LayoutContentPane,
    LayoutContentPaneType,
    LayoutTopPaneRSC as LayoutTopPane,
    LayoutTopPaneType,
    RetainBehaviorModifier,
    RetainSizeModifier,
} from '../../../MyStichtingOpenComponents/src'

interface AppLayoutProps {
    children: ReactElement[] | ReactElement
}

const AppLayout = ({ children }: AppLayoutProps): JSX.Element => {
    return (
        <>
            <Layout retainSize={RetainSizeModifier.FULL_WIDTH}>
                <LayoutTopPane paneType={LayoutTopPaneType.TOP_PANE_FIXED}>
                    <AppHeader />
                </LayoutTopPane>
                <LayoutContentPane
                    fillAvailableHeight={false}
                    paneType={LayoutContentPaneType.CONTENT}
                    customRetainBehaviorModifier={RetainBehaviorModifier.PADDING_INVERTED}
                >
                    {children}
                </LayoutContentPane>
            </Layout>
        </>
    )
}

export default AppLayout
